<div class="skill-history-chart">
  <div class="skill-history-chart__item" *ngFor="let chart of skillCharts; let i = index">
    <h3 class="skill-history-chart__title">{{ chart.skill.name }}</h3>
    
    <apx-chart
      [id]="'chart-' + i" 
      [series]="chart.chartOptions.series"
      [chart]="chart.chartOptions.chart"
      [xaxis]="chart.chartOptions.xaxis"
      [yaxis]="chart.chartOptions.yaxis"
      [colors]="chart.chartOptions.colors"
      [dataLabels]="chart.chartOptions.dataLabels"
      [plotOptions]="chart.chartOptions.plotOptions"
      [tooltip]="chart.chartOptions.tooltip"
      [key]="chart.skill._id"
      >
    </apx-chart>
    
    <p class="skill-history-chart__description">
      {{ chart.levelDescription }}
    </p>
  </div>
</div>
